/**
 * Collection file for languages
 * Be aware that vue-i18n warnings refer only to the reference, not to where it is being used!
 * this means that if messages.header.title does NOT guarantee the warning comes from header.
 * Source: https://kazupon.github.io/vue-i18n/introduction.html
 */

// Languages
import enUS from '@js/libs/internationalization/languages/en-US.json'
import enLX from '@js/libs/internationalization/languages/en-LX.json'
import frFR from '@js/libs/internationalization/languages/fr-FR.json'
import itIT from '@js/libs/internationalization/languages/it-IT.json'
import VueI18n from 'vue-i18n'
import { LocaleOverview } from '@js/interfaces'
/**
 * Used to test if all fields have been made translation ready.
 * Copies en-US the specified language (usually master) and replaces all values with 'xxxx'.
 */
const getDebugLanguage = (language: VueI18n.LocaleMessages): VueI18n.LocaleMessages | null => {
  if (process.env.NODE_ENV === 'development') {
    const test = JSON.stringify(language)
      .replace(/(?::")(.*?)(?:")/g, ':"xxxx"')
      .replace(/(?:"icon":)(?:.*?)(?:")(.*?)(?:")/g, '"icon": "xxxx.png"') as string
    const testObj: VueI18n.LocaleMessages = JSON.parse(test)

    testObj.localeInformation.name = testObj.localeInformation.locale = 'Test'

    return testObj
  }

  return null
}

const internationalization = () => {
  const languages: VueI18n.LocaleMessages =  {
    'en-US': enUS,
    'en-LX': enLX,
    'fr-FR': frFR,
    'it-IT': itIT
  }

  const testLanguage = getDebugLanguage(enUS)

  if(testLanguage) languages.Test = testLanguage

  const localeOverview: LocaleOverview[] = Object.keys(languages).map(language =>
    languages[language].localeInformation as VueI18n.LocaleMessage & LocaleOverview
  )

  return {
    defaultLocale: 'en-US',
    languages,
    localeOverview
  }
}

export const changeFavIcon = (href: string) => {
  const link = (document.querySelector('link[rel*=\'icon\']') || document.createElement('link')) as HTMLLinkElement
  link.type = 'image/png'
  link.rel = 'shortcut icon'
  link.href = href
  document.getElementsByTagName('head')[0].appendChild(link)
}

const exports = internationalization()
export default exports
